import React, { memo } from "react";
import { ReactElement } from "react";
import { UX4_PRIMARY_ORANGE } from "@cart-ui/constants/Color";

function OfficeAddressIconv4(props: { className?: string }): ReactElement {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
        >
            <rect x="2.95312" y="9.14844" width="18.0941" height="12.9318" rx="1.83028" fill={UX4_PRIMARY_ORANGE} />
            <path
                d="M7.41406 5.74711C7.41406 4.53411 8.39739 3.55078 9.6104 3.55078H14.3901C15.6031 3.55078 16.5865 4.53411 16.5865 5.74711V6.9603H7.41406V5.74711Z"
                fill={UX4_PRIMARY_ORANGE}
            />
        </svg>
    );
}

export default memo(OfficeAddressIconv4);
